(function () {
  'use strict';
  var cfg = window.themeConfig || { cartType: 'drawer', routes: { root: '/', cart: '/cart', add: '/cart/add', change: '/cart/change', predictive: '/search/suggest' } };
  var r = cfg.routes;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var body = document.body;
  var lastFocus = null;

  /* ---------- Overlays ---------- */
  function openEl(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); body.classList.add('no-scroll');
    var f = $('button[data-drawer-close], button[data-menu-close], a, button', $('.drawer__panel, .mobile-menu__panel', el) || el);
    if (f) setTimeout(function () { f.focus(); }, 60);
  }
  function closeEl(el) {
    if (!el) return;
    el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open,.mobile-menu.is-open')) body.classList.remove('no-scroll');
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }
  function closeSearch() {
    var p = $('[data-search-panel]'); if (!p || p.hidden) return;
    p.hidden = true;
    var t = $('[data-search-toggle]'); if (t) t.setAttribute('aria-expanded', 'false');
  }
  function closeAll() {
    $$('.drawer.is-open,.mobile-menu.is-open').forEach(closeEl);
    var f = $('[data-filters]'); if (f) f.classList.remove('is-open');
    body.classList.remove('no-scroll');
    closeSearch();
  }

  /* Fokus im geöffneten Drawer/Menü halten */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var open = $('.drawer.is-open,.mobile-menu.is-open');
    if (!open) return;
    var items = $$('a[href],button:not([disabled]),input:not([disabled]),select,textarea,summary', open).filter(function (el) { return el.offsetParent !== null; });
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  function updateCount(n, total) {
    $$('[data-cart-count]').forEach(function (el) {
      if (el.classList.contains('cart-count')) { el.textContent = n; el.hidden = !(Number(n) > 0); }
    });
    if (total) $$('[data-cart-total]').forEach(function (el) { if (!el.hasAttribute('data-drawer-inner')) el.textContent = total; });
  }

  async function refreshCart() {
    var drawer = $('#CartDrawer');
    if (drawer) {
      try {
        var res = await fetch(r.root + '?sections=cart-drawer');
        var json = await res.json();
        var doc = new DOMParser().parseFromString(json['cart-drawer'], 'text/html');
        var fresh = $('[data-drawer-inner]', doc), cur = $('[data-drawer-inner]', drawer);
        if (fresh && cur) { cur.replaceWith(fresh); updateCount(fresh.getAttribute('data-cart-count'), fresh.getAttribute('data-cart-total')); return; }
      } catch (e) { /* fall through */ }
    }
    try { var c = await (await fetch(r.root + 'cart.js')).json(); var tot = null; try { tot = (c.total_price / 100).toLocaleString('de-DE', { style: 'currency', currency: c.currency || 'EUR' }); } catch (x) {} updateCount(c.item_count, tot); } catch (e) {}
  }

  window.mementoUI = { open: openEl, close: closeEl, refreshCart: function () { return refreshCart(); } };

  async function changeLine(line, qty) {
    try {
      var res = await fetch(r.change + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: Number(qty) })
      });
      var data = await res.json();
      if (data.status && data.description) alert(data.description);
    } catch (e) {}
    if ($('[data-cart-page]')) { location.reload(); return; }
    await refreshCart();
  }

  /* ---------- Delegated clicks ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cart-open],[data-menu-open],[data-menu-close],[data-drawer-close],[data-search-toggle],[data-filter-toggle],[data-remove],[data-qty-minus],[data-qty-plus],[data-thumb],[data-to-top]');
    if (!t) return;

    if (t.hasAttribute('data-cart-open')) {
      var d = $('#CartDrawer');
      if (d && !$('[data-cart-page]')) { e.preventDefault(); openEl(d); }
    } else if (t.hasAttribute('data-menu-open')) {
      openEl($('#MobileMenu'));
    } else if (t.hasAttribute('data-menu-close')) {
      closeEl($('#MobileMenu'));
    } else if (t.hasAttribute('data-drawer-close')) {
      closeEl($('#CartDrawer'));
    } else if (t.hasAttribute('data-search-toggle')) {
      var p = $('[data-search-panel]');
      p.hidden = !p.hidden;
      t.setAttribute('aria-expanded', String(!p.hidden));
      if (!p.hidden) { var i = $('input[type=search]', p); if (i) i.focus(); }
    } else if (t.hasAttribute('data-filter-toggle')) {
      var f = $('[data-filters]');
      if (f) {
        var open = !f.classList.contains('is-open');
        f.classList.toggle('is-open', open);
        $$('.filter-toggle').forEach(function (b) { b.setAttribute('aria-expanded', String(open)); });
        if (!open) { var tb = $('.filter-toggle'); if (tb && tb.getBoundingClientRect().top < 0) tb.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
      }
    } else if (t.hasAttribute('data-remove')) {
      e.preventDefault();
      changeLine(t.getAttribute('data-line'), 0);
    } else if (t.hasAttribute('data-qty-minus') || t.hasAttribute('data-qty-plus')) {
      var input = $('.qty__input', t.closest('.qty'));
      var v = Number(input.value) || 0;
      v = t.hasAttribute('data-qty-plus') ? v + 1 : v - 1;
      var min = input.hasAttribute('data-line') ? 0 : 1;
      var max = input.hasAttribute('max') ? Number(input.getAttribute('max')) : Infinity;
      input.value = Math.min(max, Math.max(min, v));
      if (input.hasAttribute('data-line')) changeLine(input.getAttribute('data-line'), input.value);
    } else if (t.hasAttribute('data-thumb')) {
      showMedia(t.closest('[data-product]'), t.getAttribute('data-thumb'));
    } else if (t.hasAttribute('data-to-top')) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  });

  document.addEventListener('change', function (e) {
    var el = e.target;
    if (el.classList && el.classList.contains('qty__input') && el.hasAttribute('data-line')) changeLine(el.getAttribute('data-line'), el.value);
    if (el.hasAttribute && el.hasAttribute('data-auto-submit') && el.form) el.form.submit();
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* ---------- Add to cart (AJAX) ---------- */
  document.addEventListener('submit', async function (e) {
    var form = e.target.closest('[data-ajax-add]');
    if (!form) return;
    e.preventDefault();
    var btn = $('[data-add-btn]', form), err = $('[data-form-error]', form);
    if (btn && btn.disabled) return;
    var label = btn ? btn.textContent : '';
    if (err) err.textContent = '';
    if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
    var ok = false;
    try {
      var res = await fetch(r.add + '.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: new FormData(form) });
      var data = await res.json();
      if (data.status) throw new Error(data.description || data.message || 'Der Artikel konnte nicht hinzugefügt werden.');
      var drawer = $('#CartDrawer');
      if (cfg.cartType === 'drawer' && drawer) { await refreshCart(); if (window.mementoFly) { try { await window.mementoFly(form); } catch (x) {} } openEl(drawer); ok = true; }
      else { location.href = r.cart; return; }
    } catch (ex) {
      if (err) err.textContent = ex.message; else alert(ex.message);
    } finally {
      if (btn) {
        btn.classList.remove('is-loading'); btn.disabled = false;
        if (ok && btn.hasAttribute('data-add-btn')) {
          btn.textContent = 'Hinzugefügt ✓';
          setTimeout(function () { btn.textContent = label; }, 1800);
        }
      }
    }
  });

  /* ---------- Product page ---------- */
  function showMedia(root, id) {
    if (!root || !id) return;
    $$('[data-slide]', root).forEach(function (s) { s.hidden = s.getAttribute('data-slide') !== String(id); });
    $$('[data-thumb]', root).forEach(function (th) { th.classList.toggle('is-active', th.getAttribute('data-thumb') === String(id)); });
  }

  function stockHtml(v) {
    if (!v.available) return '<span class="stock__dot stock__dot--out"></span>Ausverkauft';
    if (v.stock && v.stock <= 5) return '<span class="stock__dot stock__dot--low"></span>Nur noch ' + v.stock + ' auf Lager';
    return '<span class="stock__dot"></span>Auf Lager';
  }

  $$('[data-product]').forEach(function (root) {
    var script = $('[data-variants]', root);
    if (!script) return;
    var variants = JSON.parse(script.textContent);
    var idInput = $('[data-variant-id]', root), btn = $('[data-add-btn]', root), priceBox = $('[data-price]', root), stock = $('[data-stock]', root), sku = $('[data-sku]', root);
    function update() {
      var selected = $$('[data-option]', root).map(function (f) { var c = $('input:checked', f); return c ? c.value : null; });
      var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === selected[i]; }); });
      if (!v) { btn.disabled = true; btn.textContent = 'Nicht verfügbar'; if (stock) stock.innerHTML = '<span class="stock__dot stock__dot--out"></span>Diese Kombination ist nicht verfügbar'; return; }
      idInput.value = v.id;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
      btn.disabled = !v.available;
      btn.textContent = v.available ? (btn.getAttribute('data-label') || 'In den Warenkorb') : 'Ausverkauft';
      if (stock) stock.innerHTML = stockHtml(v);
      if (sku && v.sku) sku.textContent = v.sku;
      priceBox.innerHTML = '<div class="price' + (v.compare ? ' price--sale' : '') + '">' +
        (v.compare ? '<s class="price__compare">' + v.compare + '</s>' : '') +
        '<span class="price__current">' + v.price + '</span>' +
        (v.unit ? '<span class="price__unit">' + v.unit + '</span>' : '') + '</div>';
      var sp = $('[data-sticky-price]');
      if (sp) sp.textContent = v.price;
      if (v.media) showMedia(root, v.media);
      var url = new URL(location.href); url.searchParams.set('variant', v.id);
      history.replaceState(null, '', url.toString());
    }
    $$('[data-option] input', root).forEach(function (i) { i.addEventListener('change', update); });
  });

  /* ---------- Kaufleiste beim Runterscrollen: erscheint, sobald der Kauf-Knopf aus dem Bild ist, und verschwindet am Seitenende ---------- */
  var sticky = $('[data-sticky-atc]'), mainBtn = $('[data-product] [data-add-btn]');
  if (sticky && mainBtn && 'IntersectionObserver' in window) {
    var sb = $('[data-sticky-submit]', sticky), past = false, atEnd = false, onNow = null;
    sticky.hidden = false;
    function setSticky() {
      var on = past && !atEnd; if (on === onNow) return; onNow = on;
      sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      sb.tabIndex = on ? 0 : -1; body.classList.toggle('has-sticky-atc', on);
    }
    /* Ganz unten macht die Leiste Platz, damit die letzte Zeile des Footers frei lesbar ist */
    function endCheck() { atEnd = (document.documentElement.scrollHeight - innerHeight - scrollY) < 110; setSticky(); }
    new IntersectionObserver(function (en) { past = !en[0].isIntersecting && en[0].boundingClientRect.top < 0; setSticky(); }).observe(mainBtn);
    var et = false;
    window.addEventListener('scroll', function () { if (!et) { et = true; requestAnimationFrame(function () { et = false; endCheck(); }); } }, { passive: true });
    window.addEventListener('resize', endCheck); endCheck();
    sb.addEventListener('click', function () { if (!mainBtn.disabled) mainBtn.click(); });
    /* Der Knopf in der Leiste zeigt immer dasselbe wie der Kauf-Knopf (Variante, Laden, „Hinzugefügt ✓“) */
    function mirror() { sb.textContent = mainBtn.textContent; sb.disabled = mainBtn.disabled; sb.classList.toggle('is-loading', mainBtn.classList.contains('is-loading')); }
    if (window.MutationObserver) new MutationObserver(mirror).observe(mainBtn, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'class'] });
  }

  /* ---------- Recommendations ---------- */
  $$('[data-recommendations]').forEach(async function (el) {
    try {
      var res = await fetch(el.getAttribute('data-url'));
      var html = await res.text();
      var fresh = $('[data-recommendations]', new DOMParser().parseFromString(html, 'text/html'));
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    } catch (e) {}
  });

  /* ---------- Filters ---------- */
  var ff = $('[data-filter-form]');
  if (ff) {
    var timer;
    $$('[data-filter-input]', ff).forEach(function (i) {
      i.addEventListener('change', function () { clearTimeout(timer); timer = setTimeout(function () { ff.submit(); }, 250); });
    });
  }

  /* ---------- Live-Suche ---------- */
  var sInput = $('[data-search-input]'), sBox = $('[data-predictive]');
  if (sInput && sBox && r.predictive) {
    var sTimer, sCtrl;
    var feat = cfg.features || {};
    var esc = function (t) { return String(t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
    var recentQ = function () { try { return JSON.parse(localStorage.getItem('mcSearch') || '[]'); } catch (e) { return []; } };
    var saveQ = function (q) { q = String(q || '').trim(); if (q.length < 2) return; try { var l = recentQ().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); }); l.unshift(q); localStorage.setItem('mcSearch', JSON.stringify(l.slice(0, 6))); } catch (e) {} };
    /* Leeres Suchfeld: zuletzt gesucht und beliebte Begriffe als Vorschläge */
    var suggest = function () {
      if (!feat.searchSuggest) return false;
      var rec = recentQ(), pop = String(feat.searchPopular || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
      if (!rec.length && !pop.length) return false;
      var chip = function (q, cls) { return '<button type="button" class="sugg__chip' + (cls || '') + '" data-sugg="' + esc(q) + '">' + esc(q) + '</button>'; };
      sBox.innerHTML = '<div class="sugg">' +
        (rec.length ? '<div class="sugg__group"><p class="sugg__title">Zuletzt gesucht<button type="button" class="sugg__clear" data-sugg-clear>Löschen</button></p><div class="sugg__chips">' + rec.map(function (q) { return chip(q, ' sugg__chip--recent'); }).join('') + '</div></div>' : '') +
        (pop.length ? '<div class="sugg__group"><p class="sugg__title">Beliebt</p><div class="sugg__chips">' + pop.map(function (q) { return chip(q); }).join('') + '</div></div>' : '') + '</div>';
      sBox.hidden = false; return true;
    };
    sBox.addEventListener('click', function (e) {
      var c = e.target.closest('[data-sugg]');
      if (c) { e.preventDefault(); sInput.value = c.getAttribute('data-sugg'); saveQ(sInput.value); sInput.form.submit(); return; }
      if (e.target.closest('[data-sugg-clear]')) { e.preventDefault(); try { localStorage.removeItem('mcSearch'); } catch (x) {} if (!suggest()) sBox.hidden = true; sInput.focus(); return; }
      if (e.target.closest('a')) saveQ(sInput.value);
    });
    sInput.form.addEventListener('submit', function () { saveQ(sInput.value); });
    var runSearch = async function () {
      var q = sInput.value.trim();
      if (q.length < 2) { if (document.activeElement === sInput && suggest()) return; sBox.hidden = true; sBox.innerHTML = ''; return; }
      if (sCtrl) sCtrl.abort();
      sCtrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var url = r.predictive + '?q=' + encodeURIComponent(q) + '&section_id=predictive-search&resources[type]=product,collection,query&resources[limit]=6&resources[limit_scope]=each';
      try {
        var res = await fetch(url, sCtrl ? { signal: sCtrl.signal } : undefined);
        if (!res.ok) throw new Error('search');
        var html = await res.text();
        var fresh = $('#predictive-search-results', new DOMParser().parseFromString(html, 'text/html'));
        if (fresh) { sBox.innerHTML = fresh.innerHTML; sBox.hidden = false; }
      } catch (e) { /* Abbruch oder Fehler: normale Suche bleibt nutzbar */ }
    };
    sInput.addEventListener('input', function () { clearTimeout(sTimer); sTimer = setTimeout(runSearch, 250); });
    sInput.addEventListener('focus', function () { if (sInput.value.trim().length < 2) { if (!suggest() && sBox.innerHTML.trim()) sBox.hidden = false; } else if (sBox.innerHTML.trim()) sBox.hidden = false; });
    document.addEventListener('click', function (e) { if (!e.target.closest('.hsearch')) sBox.hidden = true; });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') sBox.hidden = true; });
  }


  /* ---------- Footer: auf dem Handy aufklappbar ---------- */
  var accs = $$('[data-footer-acc]');
  if (accs.length && window.matchMedia) {
    var mqf = window.matchMedia('(max-width: 700px)');
    var setAcc = function () { accs.forEach(function (d) { if (mqf.matches) d.removeAttribute('open'); else d.setAttribute('open', ''); }); };
    setAcc(); if (mqf.addEventListener) mqf.addEventListener('change', setAcc);
    accs.forEach(function (d) { var s = $('summary', d); if (s) s.addEventListener('click', function (e) { if (!mqf.matches) e.preventDefault(); }); });
  }

  /* ---------- Release-Kalender: Reiter ---------- */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-tab]'); if (!tab) return;
    var root = tab.closest('[data-tabs]'); if (!root) return;
    var g = tab.getAttribute('data-tab');
    $$('[data-tab]', root).forEach(function (b) { var on = b === tab; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', String(on)); });
    $$('[data-group]', root).forEach(function (it) { it.hidden = !(g === 'all' || it.getAttribute('data-group') === g); });
    var tr = $('[data-slider]', root); if (tr) tr.scrollLeft = 0;
  });

  /* ---------- Produkt-Slider (Pfeile) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-slide]'); if (!b) return;
    var track = document.getElementById(b.getAttribute('aria-controls')); if (!track) return;
    var step = Math.max(track.clientWidth * 0.85, 200);
    track.scrollBy({ left: b.getAttribute('data-slide') === 'next' ? step : -step, behavior: 'smooth' });
  });

  /* ---------- Ankündigungsleiste (mobil rotierend) ---------- */
  var ann = $('.announcement');
  if (ann && window.matchMedia) {
    var items = $$('.announcement__item', ann);
    if (items.length > 1) {
      var mq = window.matchMedia('(max-width: 700px)'), idx = 0, iv;
      var start = function () {
        stop();
        if (!mq.matches) return;
        ann.setAttribute('data-rotating', '');
        items.forEach(function (el, i) { el.classList.toggle('is-active', i === idx); });
        iv = setInterval(function () { idx = (idx + 1) % items.length; items.forEach(function (el, i) { el.classList.toggle('is-active', i === idx); }); }, 4000);
      };
      var stop = function () { clearInterval(iv); ann.removeAttribute('data-rotating'); items.forEach(function (el) { el.classList.remove('is-active'); }); };
      start();
      if (mq.addEventListener) mq.addEventListener('change', start);
    }
  }

  /* ---------- Header shadow ---------- */
  var header = $('#Header');
  if (header) {
    /* Header verschwindet beim Runterscrollen und erscheint sofort beim Hochscrollen */
    var wrap = header.closest('.shopify-section') || header, lastY = window.scrollY, ticking = false;
    var onScroll = function () {
      var y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 8);
      var tt = $('[data-to-top]'); if (tt) tt.classList.toggle('is-visible', y > 600);
      if (header.classList.contains('header--sticky')) {
        var busy = $('.mobile-menu.is-open,.drawer.is-open') || (document.activeElement && document.activeElement.matches && document.activeElement.matches('[data-search-input]'));
        var limit = header.offsetHeight + 40;
        if (busy || y < limit || y < lastY - 2) wrap.classList.remove('header-hidden');
        else if (y > lastY + 4) wrap.classList.add('header-hidden');
      }
      lastY = y; ticking = false;
    };
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true }); onScroll();
  }
})();

/* ===== Design „Lumen“: Licht, Acryl und Bewegung ===== */
(function () {
  var b = document.body;
  if (!b || b.getAttribute('data-style') !== 'lumen') return;
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  b.classList.add('lumen-js');
  if (calm) b.classList.add('lumen-calm');
  function q(s, r) { return (r || document).querySelector(s); }
  function qa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* 2) Banner: Taschenlampe + Acryl-Hülle mit Holo-Schimmer */
  var hero = q('.grading') || q('.hero'), slab = q('.hero__slab');
  if (hero && slab && !calm) {
    var raf2 = 0;
    function setTilt(x, y, lit) {
      slab.style.setProperty('--tx', x.toFixed(3)); slab.style.setProperty('--ty', y.toFixed(3));
      slab.classList.toggle('is-lit', !!lit);
    }
    if (fine) {
      hero.addEventListener('pointermove', function (e) {
        var hr = hero.getBoundingClientRect(), r = slab.getBoundingClientRect(), cx = r.left + r.width / 2, cy = r.top + r.height / 2;
        var x = Math.max(-1, Math.min(1, (e.clientX - cx) / (window.innerWidth / 2))), y = Math.max(-1, Math.min(1, (e.clientY - cy) / (window.innerHeight / 2)));
        var hx = ((e.clientX - hr.left) / hr.width * 100).toFixed(2) + '%', hy = ((e.clientY - hr.top) / hr.height * 100).toFixed(2) + '%';
        if (raf2) cancelAnimationFrame(raf2);
        raf2 = requestAnimationFrame(function () { hero.style.setProperty('--hx', hx); hero.style.setProperty('--hy', hy); hero.classList.add('is-lit'); setTilt(x, y, true); });
      });
      hero.addEventListener('pointerleave', function () { hero.classList.remove('is-lit'); setTilt(0, 0, false); });
    } else {
      /* Handy: die Hülle neigt sich beim Scrollen, das Licht wandert mit */
      var ticking = false, stopT = 0;
      window.addEventListener('scroll', function () {
        if (ticking) return; ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var r = slab.getBoundingClientRect();
          if (r.bottom < 0 || r.top > window.innerHeight) return;
          var p = Math.max(-1, Math.min(1, (r.top + r.height / 2 - window.innerHeight / 2) / (window.innerHeight / 2)));
          setTilt(-p * .55, p * .7, true);
          hero.style.setProperty('--hx', (50 + p * 30).toFixed(1) + '%'); hero.style.setProperty('--hy', (40 - p * 20).toFixed(1) + '%'); hero.classList.add('is-lit');
          clearTimeout(stopT); stopT = setTimeout(function () { slab.classList.remove('is-lit'); }, 900);
        });
      }, { passive: true });
    }
  }

  /* 4) Nahtloser Bild-Übergang zur Produktseite (View Transitions, wo der Browser es kann) */
  window.addEventListener('pageshow', function () { qa('[data-vt]').forEach(function (img) { img.style.viewTransitionName = ''; img.removeAttribute('data-vt'); }); });
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a'); if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
    var card = a.closest('.card'); if (!card) return;
    var img = q('.card__img', card); if (!img) return;
    qa('[data-vt]').forEach(function (x) { x.style.viewTransitionName = ''; x.removeAttribute('data-vt'); });
    img.style.viewTransitionName = 'mc-product'; img.setAttribute('data-vt', '');
  }, true);

  /* 6) Licht über der ganzen Seite: ein weicher Lichtschein folgt der Maus */
  if (fine && !calm) {
    var glow = document.createElement('div'); glow.className = 'lumen-glow'; glow.setAttribute('aria-hidden', 'true'); b.appendChild(glow);
    var gx = innerWidth / 2, gy = innerHeight / 3, tx2 = gx, ty2 = gy, running = false;
    function step() { gx += (tx2 - gx) * .14; gy += (ty2 - gy) * .14; glow.style.transform = 'translate3d(' + (gx - 300) + 'px,' + (gy - 300) + 'px,0)'; if (Math.abs(tx2 - gx) + Math.abs(ty2 - gy) > .5) requestAnimationFrame(step); else running = false; }
    window.addEventListener('pointermove', function (e) { if (e.pointerType !== 'mouse') return; tx2 = e.clientX; ty2 = e.clientY; glow.classList.add('is-on'); if (!running) { running = true; requestAnimationFrame(step); } }, { passive: true });
    document.addEventListener('mouseleave', function () { glow.classList.remove('is-on'); });
  }

  /* 8) Magnetische Knöpfe + Lichtimpuls beim Klick */
  if (fine && !calm) {
    qa('.hero__buttons .btn, .footer__news .btn, .cart-summary .btn, [data-product] [data-add-btn]').forEach(function (btn) {
      btn.classList.add('is-magnetic');
      btn.addEventListener('pointermove', function (e) {
        var r = btn.getBoundingClientRect(), x = e.clientX - r.left - r.width / 2, y = e.clientY - r.top - r.height / 2;
        btn.style.setProperty('--bx', (x * .22).toFixed(1) + 'px'); btn.style.setProperty('--by', (y * .3).toFixed(1) + 'px');
        btn.style.setProperty('--gx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
      });
      btn.addEventListener('pointerleave', function () { btn.style.setProperty('--bx', '0px'); btn.style.setProperty('--by', '0px'); });
    });
  }
  if (!calm) {
    document.addEventListener('pointerdown', function (e) {
      var btn = e.target.closest('.btn'); if (!btn) return;
      var r = btn.getBoundingClientRect(), d = Math.max(r.width, r.height) * 2.2, s = document.createElement('span');
      s.className = 'lumen-burst'; s.style.cssText = 'width:' + d + 'px;height:' + d + 'px;left:' + (e.clientX - r.left - d / 2) + 'px;top:' + (e.clientY - r.top - d / 2) + 'px';
      btn.appendChild(s); setTimeout(function () { s.remove(); }, 700);
    });
  }

  /* 10) Feine Fortschrittslinie unter dem Header */
  var bar = document.createElement('div'); bar.className = 'lumen-progress'; bar.setAttribute('aria-hidden', 'true');
  var hdr = q('.header'); if (hdr) hdr.appendChild(bar);
  var pt = false;
  function prog() { pt = false; var h = document.documentElement.scrollHeight - innerHeight; bar.style.transform = 'scaleX(' + (h > 0 ? Math.min(1, scrollY / h) : 0).toFixed(4) + ')'; }
  window.addEventListener('scroll', function () { if (!pt) { pt = true; requestAnimationFrame(prog); } }, { passive: true }); prog();

  /* ===== Handy-Effekte ===== */
  var touch = !fine;
  /* 13) Bereiche erscheinen beim Runterscrollen einmal als Ganzes – die Produkte darin bewegen sich nicht */
  if (!calm && 'IntersectionObserver' in window) {
    var secs = qa('#MainContent > .shopify-section');
    var rev = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (!e.isIntersecting) return; rev.unobserve(e.target); e.target.classList.add('is-in'); });
    }, { threshold: .08, rootMargin: '0px 0px -6% 0px' });
    secs.forEach(function (sec) { sec.classList.add('reveal'); rev.observe(sec); });
  }
  /* 14) Banner beim Scrollen: die Hülle dreht sich im Raum und schwebt zurück */
  if (!calm && slab) {
    var st = false;
    function heroScroll() {
      st = false;
      var r = slab.getBoundingClientRect(), p = Math.max(-1, Math.min(1, (r.top + r.height / 2 - innerHeight / 2) / innerHeight));
      slab.style.setProperty('--sp', p.toFixed(3));
    }
    window.addEventListener('scroll', function () { if (!st) { st = true; requestAnimationFrame(heroScroll); } }, { passive: true }); heroScroll();
  }
  /* 17) Handy neigen (Android): Hülle und Licht folgen der Neigung */
  if (touch && !calm && slab && 'DeviceOrientationEvent' in window && typeof DeviceOrientationEvent.requestPermission !== 'function') {
    var base = null;
    window.addEventListener('deviceorientation', function (e) {
      if (e.gamma == null) return;
      if (!base) base = { b: e.beta, g: e.gamma };
      var x = Math.max(-1, Math.min(1, (e.gamma - base.g) / 25)), y = Math.max(-1, Math.min(1, (e.beta - base.b) / 25));
      slab.style.setProperty('--tx', x.toFixed(3)); slab.style.setProperty('--ty', y.toFixed(3)); slab.classList.add('is-lit');
    });
  }

  /* 5) Flug in den Warenkorb */
  window.mementoFly = function (form) {
    return new Promise(function (resolve) {
      var cart = q('.header .cart-ico') || q('[data-cart-count]');
      var card = form.closest('.card'), src = null;
      if (card) src = q('.card__img', card);
      if (!src) src = q('[data-product] .gallery__slide:not([hidden]) img');
      if (calm || !cart || !src || !src.getBoundingClientRect || !document.body.animate) { resolve(); return; }
      var a = src.getBoundingClientRect(), c = cart.getBoundingClientRect();
      if (!a.width) { resolve(); return; }
      var size = Math.min(a.width, a.height, 160);
      var fly = document.createElement('div');
      fly.className = 'lumen-fly';
      fly.style.cssText = 'left:' + (a.left + a.width / 2 - size / 2) + 'px;top:' + (a.top + a.height / 2 - size / 2) + 'px;width:' + size + 'px;height:' + size + 'px;background-image:url("' + (src.currentSrc || src.src) + '")';
      document.body.appendChild(fly);
      var dx = c.left + c.width / 2 - (a.left + a.width / 2), dy = c.top + c.height / 2 - (a.top + a.height / 2);
      var anim = fly.animate([
        { transform: 'translate(0,0) scale(1) rotate(0)', opacity: 1 },
        { transform: 'translate(' + dx * .45 + 'px,' + (dy * .45 - 120) + 'px) scale(.62) rotate(-8deg)', opacity: 1, offset: .55 },
        { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.12) rotate(-14deg)', opacity: .2 }
      ], { duration: 820, easing: 'cubic-bezier(.55,0,.25,1)' });
      anim.onfinish = function () {
        fly.remove(); cart.classList.remove('is-glint'); void cart.offsetWidth; cart.classList.add('is-glint'); try { if (navigator.vibrate) navigator.vibrate([12, 40, 18]); } catch (x) {}
        setTimeout(function () { cart.classList.remove('is-glint'); }, 900);
        resolve();
      };
      setTimeout(resolve, 1200);
    });
  };
})();

/* ===== Design „Lumen“: Bühnen-Effekte (zusätzlich zu Licht & Acryl) ===== */
(function () {
  var b = document.body;
  if (!b || b.getAttribute('data-style') !== 'lumen') return;
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (calm) return;
  var mobile = window.matchMedia('(max-width: 700px)');
  function q(s, r) { return (r || document).querySelector(s); }
  function qa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function lum(c) {
    var m = String(c).trim(), r, g, bl;
    if (m[0] === '#') { if (m.length === 4) m = '#' + m[1] + m[1] + m[2] + m[2] + m[3] + m[3]; r = parseInt(m.substr(1, 2), 16); g = parseInt(m.substr(3, 2), 16); bl = parseInt(m.substr(5, 2), 16); }
    else { var p = m.match(/[\d.]+/g) || [0, 0, 0]; r = +p[0]; g = +p[1]; bl = +p[2]; }
    return (0.299 * r + 0.587 * g + 0.114 * bl) / 255;
  }

  /* A) Laufband: die Hinweise laufen endlos durch */
  var ann = q('.announcement'), inner = ann && q('.announcement__inner', ann);
  if (inner) {
    var items = qa('.announcement__item', inner);
    if (items.length) {
      var track = document.createElement('div'); track.className = 'ann-track';
      var copies = items.length < 3 ? 4 : 2;
      for (var c = 0; c < copies; c++) items.forEach(function (it) { var n = c === 0 ? it : it.cloneNode(true); if (c) n.setAttribute('aria-hidden', 'true'); track.appendChild(n); });
      inner.appendChild(track); ann.classList.add('is-marquee');
      track.style.setProperty('--ann-shift', (-100 / copies) + '%');
      track.style.setProperty('--ann-time', Math.max(18, items.length * 9) + 's');
    }
  }

  /* B) Banner: die Überschrift zoomt beim Scrollen davon, Text und Knöpfe schweben weg */
  var hero = q('.hero');
  if (hero) {
    var hs = false;
    function heroOut() { hs = false; var r = hero.getBoundingClientRect(); var p = Math.max(0, Math.min(1, -r.top / Math.max(1, r.height * .8))); hero.style.setProperty('--hp', p.toFixed(3)); }
    window.addEventListener('scroll', function () { if (!hs) { hs = true; requestAnimationFrame(heroOut); } }, { passive: true }); heroOut();
  }

  /* F) Menü: die Einträge fallen nacheinander ins Bild */
  qa('.mobile-nav > li').forEach(function (li, i) { li.style.setProperty('--i', i); });

  /* H) Fortschritt im Produkt-Slider (Handy) */
  qa('.slider').forEach(function (sl) {
    var bar = document.createElement('div'); bar.className = 'slider-progress'; bar.setAttribute('aria-hidden', 'true');
    var thumb = document.createElement('span'); bar.appendChild(thumb); sl.parentNode.insertBefore(bar, sl.nextSibling);
    var tk = false;
    function upd() {
      tk = false; var max = sl.scrollWidth - sl.clientWidth;
      bar.hidden = max < 4;
      var w = sl.clientWidth / Math.max(1, sl.scrollWidth), p = max > 0 ? sl.scrollLeft / max : 0;
      thumb.style.width = (w * 100).toFixed(2) + '%'; thumb.style.transform = 'translateX(' + (p * (1 / w - 1) * 100).toFixed(2) + '%)';
    }
    sl.addEventListener('scroll', function () { if (!tk) { tk = true; requestAnimationFrame(upd); } }, { passive: true });
    window.addEventListener('resize', upd); upd();
  });

})();

/* ===== Design „Lumen“: Feinschliff-Effekte ===== */
(function () {
  var b = document.body;
  if (!b || b.getAttribute('data-style') !== 'lumen') return;
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  function q(s, r) { return (r || document).querySelector(s); }
  function qa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function raf(fn) { var t = false; return function () { if (t) return; t = true; requestAnimationFrame(function () { t = false; fn(); }); }; }

  /* 1) Live-Countdown bis zum Release (läuft auch ohne Animationen) */
  var cds = [];
  qa('.card__release').forEach(function (el) {
    var m = el.textContent.match(/(\d{2})\.(\d{2})\.(\d{4})/); if (!m) return;
    var at = new Date(+m[3], +m[2] - 1, +m[1], 0, 0, 0).getTime();
    var span = document.createElement('p'); span.className = 'cd'; span.setAttribute('aria-hidden', 'true');
    el.parentNode.insertBefore(span, el.nextSibling); cds.push({ el: span, span: span, at: at });
  });
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  /* Fallblatt-Anzeige: jede Ziffer ist ein eigenes Blatt, das beim Wechsel umklappt */
  function board(c) {
    if (c.tiles) return;
    c.span.innerHTML = '<span class="cd__lbl">Release in</span><span class="cd__grp" data-u="T"></span><span class="cd__grp" data-u="Std"></span><span class="cd__grp" data-u="Min"></span><span class="cd__grp" data-u="Sek"></span>';
    c.tiles = Array.prototype.slice.call(c.span.querySelectorAll('.cd__grp')).map(function () { return []; });
    c.grps = Array.prototype.slice.call(c.span.querySelectorAll('.cd__grp'));
  }
  function setGroup(c, gi, str) {
    var grp = c.grps[gi], tiles = c.tiles[gi];
    while (tiles.length < str.length) { var t = document.createElement('b'); t.className = 'fd'; t.textContent = '0'; grp.appendChild(t); tiles.push(t); }
    while (tiles.length > str.length) grp.removeChild(tiles.pop());
    for (var i = 0; i < str.length; i++) {
      var t = tiles[i], v = str[i];
      if (t.textContent !== v) {
        t.setAttribute('data-old', t.textContent); t.textContent = v;
        if (!calm) { t.classList.remove('is-flip'); void t.offsetWidth; t.classList.add('is-flip'); }
      }
    }
  }
  function tick() {
    var now = Date.now();
    cds.forEach(function (c) {
      var d = c.at - now;
      if (d <= 0) { c.tiles = null; c.span.textContent = d > -864e5 ? 'Heute ist Release' : ''; c.el.classList.toggle('is-today', d > -864e5); return; }
      var s = Math.floor(d / 1000), days = Math.floor(s / 86400); s -= days * 86400;
      var h = Math.floor(s / 3600); s -= h * 3600; var mi = Math.floor(s / 60); s -= mi * 60;
      board(c); setGroup(c, 0, String(days)); setGroup(c, 1, pad(h)); setGroup(c, 2, pad(mi)); setGroup(c, 3, pad(s));
    });
  }
  if (cds.length) { tick(); setInterval(tick, 1000); }

  /* 2) Warenkorb-Zähler klappt um wie eine Karte */
  qa('.cart-count').forEach(function (badge) {
    var last = badge.textContent;
    new MutationObserver(function () {
      if (badge.textContent === last) return; last = badge.textContent;
      if (!calm && badge.animate) badge.animate([{ transform: 'perspective(200px) rotateX(-90deg) scale(.6)' }, { transform: 'perspective(200px) rotateX(20deg) scale(1.2)', offset: .6 }, { transform: 'none' }], { duration: 650, easing: 'cubic-bezier(.2,.8,.2,1)' });
    }).observe(badge, { childList: true, characterData: true, subtree: true });
  });

  /* 3) Fokus beim Suchen: alles außer der Suche tritt zurück */
  qa('.hsearch input[type=search]').forEach(function (inp) {
    var t = 0;
    inp.addEventListener('focus', function () { clearTimeout(t); b.classList.add('is-searching'); });
    inp.addEventListener('blur', function () { t = setTimeout(function () { b.classList.remove('is-searching'); }, 180); });
  });

  /* Bilder in Kacheln: passt das Format nicht, wird das ganze Bild gezeigt, statt es abzuschneiden */
  function fitTile(img) {
    var box = img.closest('.game__media, .cat-hero'); if (!box || img.classList.contains('game__img--art')) return;
    var bw = box.clientWidth, bh = box.clientHeight; if (!bw || !bh || !img.naturalWidth) return;
    var ir = img.naturalWidth / img.naturalHeight, br = bw / bh, off = Math.abs(ir - br) / br;
    box.classList.toggle('is-fit', off > .06);
    if (off > .06 && !box.querySelector('.fit-bg')) { var bg = document.createElement('span'); bg.className = 'fit-bg'; bg.setAttribute('aria-hidden', 'true'); bg.style.backgroundImage = 'url("' + (img.currentSrc || img.src) + '")'; box.insertBefore(bg, box.firstChild); }
  }
  qa('.game__media .game__img').forEach(function (img) { if (img.complete) fitTile(img); else img.addEventListener('load', function () { fitTile(img); }, { once: true }); });
  window.addEventListener('resize', raf(function () { qa('.game__media .game__img').forEach(fitTile); }));

  if (calm) return;

  /* 4) Die Acryl-Hülle als echtes 3D-Objekt: schwebt ruhig, folgt Maus, Finger, Neigung und Scrollen */
  var slabEl = q('.hero__slab'), obj = q('.slab3d'), floorEl = q('.slab3d__floor');
  if (slabEl && obj && getComputedStyle(obj).display !== 'contents') {
    var cy = -14, cx = 6, vis = true, t0 = performance.now(), lastRy = null, lastRx = null;
    if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { vis = e[0].isIntersecting; if (vis) requestAnimationFrame(loop3d); }).observe(slabEl);
    function loop3d(now) {
      if (!vis || document.hidden) return;
      var st = slabEl.style, tx = parseFloat(st.getPropertyValue('--tx')) || 0, ty = parseFloat(st.getPropertyValue('--ty')) || 0;
      var lit = slabEl.classList.contains('is-lit'), sp = parseFloat(st.getPropertyValue('--sp')) || 0, t = (now - t0) / 1000;
      var amp = lit ? 7 : 26;
      var ty3 = -6 + Math.sin(t * .5) * amp + tx * 28 + sp * 30, tx3 = 9 + Math.sin(t * .8 + 1) * (lit ? 2 : 6) - ty * 16 + sp * 14;
      cy += (ty3 - cy) * .08; cx += (tx3 - cx) * .08;
      obj.style.transform = 'rotateX(' + cx.toFixed(2) + 'deg) rotateY(' + cy.toFixed(2) + 'deg) translateY(' + (Math.sin(t * 1.1) * 6).toFixed(1) + 'px)';
      var nry = Math.round(cy / 30 * 40) / 40, nrx = Math.round(cx / 30 * 40) / 40;
      if (nry !== lastRy || nrx !== lastRx) { lastRy = nry; lastRx = nrx; obj.style.setProperty('--ry', nry.toFixed(3)); obj.style.setProperty('--rx', nrx.toFixed(3)); }
      if (floorEl) { floorEl.style.transform = 'translateX(' + (cy * .9).toFixed(1) + 'px) scale(' + (1 - Math.sin(t * 1.1) * .04).toFixed(3) + ',1)'; }
      requestAnimationFrame(loop3d);
    }
    document.addEventListener('visibilitychange', function () { if (!document.hidden) requestAnimationFrame(loop3d); });
    requestAnimationFrame(loop3d);
  }

  /* 5) Bilder laden elegant: Schimmer statt leerer Fläche, dann scharf stellen */
  qa('.card__img, .game__img, .gallery__slide img, .cat-collage__img, .cat-hero__img, .card__media img').forEach(function (img) {
    if (img.complete && img.naturalWidth) return;
    var box = img.closest('.card__media, .game__media, .gallery__slide, .cat-collage__item, .cat-hero') || img.parentNode;
    box.classList.add('is-loading');
    function done() { box.classList.remove('is-loading'); }
    img.addEventListener('load', done, { once: true }); img.addEventListener('error', done, { once: true });
  });

  /* 7) Lupe für Produktbilder: Maus darüber oder lange drücken auf dem Handy */
  qa('[data-product] .gallery__main').forEach(function (gm) {
    var lens = document.createElement('div'); lens.className = 'loupe'; lens.setAttribute('aria-hidden', 'true'); gm.appendChild(lens);
    var holdT = 0, active = false;
    function img() { return q('.gallery__slide:not([hidden]) img', gm); }
    function show(x, y, touch) {
      var im = img(); if (!im) return;
      var r = im.getBoundingClientRect(), g = gm.getBoundingClientRect();
      var rx = (x - r.left) / r.width, ry = (y - r.top) / r.height;
      if (rx < 0 || rx > 1 || ry < 0 || ry > 1) { lens.classList.remove('is-on'); return; }
      var z = 2.6, size = lens.offsetWidth || 170;
      lens.style.backgroundImage = 'url("' + (im.currentSrc || im.src) + '")';
      lens.style.backgroundSize = (r.width * z) + 'px ' + (r.height * z) + 'px';
      lens.style.backgroundPosition = (-(rx * r.width * z - size / 2)) + 'px ' + (-(ry * r.height * z - size / 2)) + 'px';
      lens.style.left = (x - g.left - size / 2) + 'px'; lens.style.top = (y - g.top - size / 2 - (touch ? size * .75 : 0)) + 'px';
      lens.classList.add('is-on'); if (touch) gm._loupeAt = Date.now();
    }
    function hide() { lens.classList.remove('is-on'); active = false; clearTimeout(holdT); }
    if (fine) {
      gm.addEventListener('pointermove', function (e) { if (e.pointerType === 'mouse') show(e.clientX, e.clientY, false); });
      gm.addEventListener('pointerleave', hide);
    }
    gm.addEventListener('touchstart', function (e) {
      var t = e.touches[0], x = t.clientX, y = t.clientY;
      clearTimeout(holdT); holdT = setTimeout(function () { active = true; show(x, y, true); try { navigator.vibrate && navigator.vibrate(8); } catch (z) {} }, 260);
    }, { passive: true });
    gm.addEventListener('touchmove', function (e) {
      if (!active) { clearTimeout(holdT); return; }
      e.preventDefault(); var t = e.touches[0]; show(t.clientX, t.clientY, true);
    }, { passive: false });
    ['touchend', 'touchcancel'].forEach(function (ev) { gm.addEventListener(ev, hide, { passive: true }); });
    gm.addEventListener('contextmenu', function (e) { if (active) e.preventDefault(); });
  });

  /* 8) Der Footer liegt unter der Seite und wird beim Scrollen aufgedeckt */
  var main = q('#MainContent'), foot = q('.footer'), fsec = foot && foot.closest('.shopify-section');
  if (main && fsec) {
    var fitCheck = function () { b.classList.toggle('has-curtain', fsec.offsetHeight < innerHeight - 12 && innerHeight > 500); };
    var near = function () { b.classList.toggle('curtain-near', (document.documentElement.scrollHeight - innerHeight - scrollY) < fsec.offsetHeight + 160); };
    window.addEventListener('scroll', near, { passive: true }); window.addEventListener('resize', near); near();
    fitCheck(); window.addEventListener('resize', fitCheck);
    qa('.footer details').forEach(function (d) { d.addEventListener('toggle', fitCheck); });
  }
})();

/* Lumen: Sobald der Slab ins Bild kommt, gleitet er herein, die Note zählt einmal hoch und ein Glanz zieht über das Etikett */
(function () {
  var b = document.body;
  if (!b || b.getAttribute('data-style') !== 'lumen') return;
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var slab = document.querySelector('.hero__slab'), label = document.querySelector('.slab3d__label');
  if (!slab) return;
  var nums = Array.prototype.slice.call(document.querySelectorAll('.slab3d__label .glabel__grade b, .slab3d__label .glabel__subs b'));
  var vals = nums.map(function (el) { return el.textContent; });
  function count() {
    nums.forEach(function (el, i) {
      var txt = vals[i], end = parseFloat(txt.replace(',', '.')); if (!(end > 0)) return;
      var dec = /\.5$/.test(txt.trim()), t0 = null, dur = 1100;
      el.textContent = dec ? '0.0' : '0';
      function step(t) {
        if (!t0) t0 = t; var k = Math.min(1, (t - t0) / dur), v = end * (1 - Math.pow(1 - k, 3));
        el.textContent = dec ? (Math.round(v * 2) / 2).toFixed(1) : String(Math.round(v));
        if (k < 1) requestAnimationFrame(step); else el.textContent = txt;
      }
      setTimeout(function () { requestAnimationFrame(step); }, 700 + i * 120);
    });
    if (label) setTimeout(function () { label.classList.add('is-flash'); setTimeout(function () { label.classList.remove('is-flash'); }, 1400); }, 2300);
  }
  if (calm || !('IntersectionObserver' in window)) return;
  slab.classList.add('is-waiting');
  var io = new IntersectionObserver(function (en) {
    if (!en[0].isIntersecting) return; io.disconnect();
    slab.classList.remove('is-waiting'); slab.classList.add('is-arrived'); count();
  }, { threshold: .35 });
  io.observe(slab);
})();

/* ===== Design „Lumen“: Spezial-Effekte ===== */
(function () {
  var b = document.body, root = document.documentElement;
  if (!b || b.getAttribute('data-style') !== 'lumen') return;
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  function q(s, r) { return (r || document).querySelector(s); }
  function qa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  var logoEl = q('.hero__logo') || q('.header__logo img, .logo-img');
  var logo = logoEl ? (logoEl.currentSrc || logoEl.src) : '';

  root.classList.remove('lumen-intro');

  if (calm) return;

  /* B) Lichtkegel mit schwebendem Staub über dem Slab */
  var hero = q('.grading') || q('.hero'), side = q('.grading__stage') || q('.hero__side');
  if (hero && side && q('.slab3d')) {
    var beam = document.createElement('span'); beam.className = 'hero__beam'; beam.setAttribute('aria-hidden', 'true'); side.insertBefore(beam, side.firstChild);
    var cv = document.createElement('canvas'); cv.className = 'hero__dust'; cv.setAttribute('aria-hidden', 'true'); side.insertBefore(cv, side.firstChild);
    var ctx = cv.getContext('2d'), dpr = Math.min(1.5, window.devicePixelRatio || 1), parts = [], W = 0, H = 0, vis = true;
    /* Ein vorgezeichnetes Lichtpünktchen statt teurer Schatten pro Bild */
    var sprite = document.createElement('canvas'); sprite.width = sprite.height = 32;
    var sg = sprite.getContext('2d'), rg = sg.createRadialGradient(16, 16, 0, 16, 16, 16);
    rg.addColorStop(0, 'rgba(255,255,255,1)'); rg.addColorStop(.25, 'rgba(255,255,255,.9)'); rg.addColorStop(1, 'rgba(255,255,255,0)'); sg.fillStyle = rg; sg.fillRect(0, 0, 32, 32);
    function size() { var r = side.getBoundingClientRect(); W = r.width; H = r.height; cv.width = W * dpr; cv.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); }
    function spawn(p, anyY) { p.x = W * (.5 + (Math.random() - .5) * .7); p.y = anyY ? Math.random() * H : H + 10; p.r = .6 + Math.random() * 1.8; p.vy = .12 + Math.random() * .35; p.vx = (Math.random() - .5) * .12; p.a = .25 + Math.random() * .6; p.tw = Math.random() * 6.28; return p; }
    size(); for (var k = 0; k < (innerWidth < 700 ? 34 : 60); k++) parts.push(spawn({}, true));
    window.addEventListener('resize', size);
    if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { vis = e[0].isIntersecting; if (vis) requestAnimationFrame(dust); }).observe(side);
    function dust() {
      if (!vis || document.hidden) return;
      ctx.globalAlpha = 1; ctx.clearRect(0, 0, W, H);
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i]; p.y -= p.vy; p.x += p.vx + Math.sin((p.y + p.tw * 40) / 60) * .08; p.tw += .03;
        if (p.y < -10) spawn(p, false);
        var cx = Math.abs(p.x - W / 2) / (W * .45), fade = Math.max(0, 1 - cx * cx) * Math.min(1, p.y / (H * .2));
        var al = p.a * fade * (.6 + .4 * Math.sin(p.tw));
        if (al < .02) continue; ctx.globalAlpha = al; var sz = p.r * 6; ctx.drawImage(sprite, p.x - sz / 2, p.y - sz / 2, sz, sz);
      }
      requestAnimationFrame(dust);
    }
    document.addEventListener('visibilitychange', function () { if (!document.hidden) requestAnimationFrame(dust); });
    requestAnimationFrame(dust);
  }

  /* C) Slab per Handy-Neigung steuern (iPhone: einmal auf den Slab tippen und erlauben) */
  var slab = q('.hero__slab');
  if (slab && !fine && 'DeviceOrientationEvent' in window && typeof DeviceOrientationEvent.requestPermission === 'function') {
    var hint = document.createElement('span'); hint.className = 'tilt-hint'; hint.textContent = 'Tippen und Handy neigen';
    slab.parentNode.appendChild(hint);
    var base = null;
    function onTilt(e) {
      if (e.gamma == null) return; if (!base) base = { b: e.beta, g: e.gamma };
      var x = Math.max(-1, Math.min(1, (e.gamma - base.g) / 22)), y = Math.max(-1, Math.min(1, (e.beta - base.b) / 22));
      slab.style.setProperty('--tx', x.toFixed(3)); slab.style.setProperty('--ty', y.toFixed(3)); slab.classList.add('is-lit');
    }
    slab.addEventListener('click', function () {
      DeviceOrientationEvent.requestPermission().then(function (r) { if (r === 'granted') { window.addEventListener('deviceorientation', onTilt); hint.classList.add('is-on'); hint.textContent = 'Neige dein Handy'; setTimeout(function () { hint.classList.add('is-gone'); }, 2600); } }).catch(function () {});
    }, { once: true });
  }

  /* D) Cursor-Ring am Computer: zeigt „Ansehen“ über Produkten und „Neigen“ über dem Slab */
  if (fine) {
    var ring = document.createElement('div'); ring.className = 'lc-ring'; ring.setAttribute('aria-hidden', 'true'); ring.innerHTML = '<span class="lc-ring__lbl"></span>';
    b.appendChild(ring);
    var lbl = ring.firstChild, mx = -100, my = -100, rx = -100, ry = -100, run = false;
    function loop() { rx += (mx - rx) * .2; ry += (my - ry) * .2; ring.style.transform = 'translate3d(' + rx.toFixed(1) + 'px,' + ry.toFixed(1) + 'px,0)'; if (Math.abs(mx - rx) + Math.abs(my - ry) > .3) requestAnimationFrame(loop); else run = false; }
    window.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return; mx = e.clientX; my = e.clientY; ring.classList.add('is-on');
      var t = e.target.closest ? e.target.closest('.card, .game, .hero__slab, .gallery__main') : null, text = '';
      if (t) text = t.classList.contains('hero__slab') ? 'Neigen' : t.classList.contains('gallery__main') ? 'Lupe' : 'Ansehen';
      ring.classList.toggle('is-big', !!text); if (text && lbl.textContent !== text) lbl.textContent = text;
      ring.classList.toggle('is-link', !text && !!(e.target.closest && e.target.closest('a, button, summary, label, input, select')));
      if (!run) { run = true; requestAnimationFrame(loop); }
    }, { passive: true });
    document.addEventListener('mouseleave', function () { ring.classList.remove('is-on'); });
    window.addEventListener('pointerdown', function () { ring.classList.add('is-press'); });
    window.addEventListener('pointerup', function () { ring.classList.remove('is-press'); });
  }

})();

/* ===== Design „Lumen“: Dunkler Modus mit kreisförmigem Übergang vom Schalter aus ===== */
(function () {
  var root = document.documentElement, b = document.body;
  var btns = Array.prototype.slice.call(document.querySelectorAll('[data-theme-toggle]'));
  if (!btns.length) return;
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var meta = document.querySelector('[data-theme-color]');
  function isDark() { return root.getAttribute('data-theme') === 'dark'; }
  function sync() {
    var d = isDark();
    btns.forEach(function (bt) {
      bt.setAttribute('aria-pressed', String(d));
      bt.setAttribute('aria-label', d ? 'Hellen Modus einschalten' : 'Dunklen Modus einschalten');
      var l = bt.querySelector('[data-theme-label]'); if (l) l.textContent = d ? 'Hell' : 'Dunkel';
    });
    if (meta) meta.setAttribute('content', d ? '#0c0e10' : '#eceff1');
  }
  function apply(d) {
    root.setAttribute('data-theme', d ? 'dark' : 'light');
    try { localStorage.setItem('mcTheme', d ? 'dark' : 'light'); } catch (e) {}
    sync();
  }
  sync();
  btns.forEach(function (bt) {
    bt.addEventListener('click', function () {
      var d = !isDark(), r = bt.getBoundingClientRect(), x = r.left + r.width / 2, y = r.top + r.height / 2;
      var far = Math.hypot(Math.max(x, innerWidth - x), Math.max(y, innerHeight - y));
      root.style.setProperty('--vx', x + 'px'); root.style.setProperty('--vy', y + 'px'); root.style.setProperty('--vr', Math.ceil(far + 40) + 'px');
      bt.classList.remove('is-spin'); void bt.offsetWidth; bt.classList.add('is-spin');
      if (calm) { apply(d); return; }
      if (!document.startViewTransition) {
        root.classList.add('theme-fade'); apply(d);
        setTimeout(function () { root.classList.remove('theme-fade'); }, 700);
        return;
      }
      root.classList.add('theme-switching'); root.classList.toggle('to-dark', d);
      var ring = document.createElement('span'); ring.className = 'theme-ring' + (d ? ' is-dark' : ''); ring.setAttribute('aria-hidden', 'true');
      var t = document.startViewTransition(function () { apply(d); b.appendChild(ring); });
      /* Lichtkante startet exakt mit der Kreis-Animation */
      t.ready.then(function () { ring.classList.add('is-go'); }, function () {});
      var safety = setTimeout(function () { ring.remove(); }, 4000);
      var done = function () {
        clearTimeout(safety); ring.remove();
        root.classList.remove('theme-switching', 'to-dark');
        /* Danach einmal Silberglanz über Überschriften und Logo */
        root.classList.remove('theme-gleam'); void root.offsetWidth; root.classList.add('theme-gleam');
        setTimeout(function () { root.classList.remove('theme-gleam'); }, 1900);
      };
      t.finished.then(done, done);
    });
  });
  /* Folgt das Gerät dem System und der Kunde hat noch nichts gewählt, mitwechseln */
  try {
    var mq = matchMedia('(prefers-color-scheme: dark)');
    if (mq.addEventListener && document.querySelector('[data-theme-auto]')) mq.addEventListener('change', function (e) { if (!localStorage.getItem('mcTheme')) { root.setAttribute('data-theme', e.matches ? 'dark' : 'light'); sync(); } });
  } catch (e) {}
})();

/* ===== Design „Lumen“, dunkler Modus: „Nacht-Showroom“ =====
   Nachthimmel mit Polarlicht und Sternenstaub, Vitrinen schalten ihr Licht ein, Lichtkanten folgen Finger und Maus,
   Lichtimpuls beim Tippen. Alles nur im dunklen Modus, einzeln in den Theme-Einstellungen abschaltbar. */
(function () {
  var root = document.documentElement, b = document.body;
  if (!b || b.getAttribute('data-style') !== 'lumen' || !root.hasAttribute('data-nfx')) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var fx = ' ' + (root.getAttribute('data-nfx') || '') + ' ';
  function has(k) { return fx.indexOf(' ' + k + ' ') > -1; }
  function dark() { return root.getAttribute('data-theme') === 'dark'; }
  function qa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function inView(el) { var r = el.getBoundingClientRect(); return r.bottom > 0 && r.top < innerHeight && r.right > 0 && r.left < innerWidth && r.width > 0; }
  var main = document.getElementById('MainContent'), small = innerWidth < 700, IO = 'IntersectionObserver' in window;

  /* 1) Nachthimmel: langsam ziehende Lichtschleier und funkelnder Staub, der beim Scrollen in die Tiefe zieht */
  var sky = null, cv, cx, stars = [], W = 0, H = 0, running = false, lastT = 0, dot, skyTick = false;
  function sprite() {
    var c = document.createElement('canvas'); c.width = c.height = 32;
    var g = c.getContext('2d'), rg = g.createRadialGradient(16, 16, 0, 16, 16, 16);
    rg.addColorStop(0, 'rgba(255,255,255,1)'); rg.addColorStop(.18, 'rgba(255,255,255,.85)'); rg.addColorStop(.5, 'rgba(225,232,238,.18)'); rg.addColorStop(1, 'rgba(225,232,238,0)');
    g.fillStyle = rg; g.fillRect(0, 0, 32, 32); return c;
  }
  function skySize() { var d = Math.min(1.5, window.devicePixelRatio || 1); W = innerWidth; H = innerHeight; cv.width = Math.round(W * d); cv.height = Math.round(H * d); cx.setTransform(d, 0, 0, d, 0, 0); }
  function skyScroll() {
    skyTick = false; if (!sky) return;
    var max = Math.max(1, document.documentElement.scrollHeight - innerHeight);
    sky.style.setProperty('--mcp', Math.min(1, scrollY / max).toFixed(3));
  }
  function skyBuild() {
    sky = document.createElement('div'); sky.className = 'mc-night'; sky.setAttribute('aria-hidden', 'true');
    sky.innerHTML = '<div class="mc-night__sky"><span class="mc-night__veil mc-night__veil--a"></span><span class="mc-night__veil mc-night__veil--b"></span><span class="mc-night__veil mc-night__veil--c"></span><span class="mc-night__ribbon"></span></div><canvas class="mc-night__stars"></canvas>';
    main.insertBefore(sky, main.firstChild);
    cv = sky.querySelector('canvas'); cx = cv.getContext('2d'); dot = sprite();
    skySize(); window.addEventListener('resize', skySize);
    for (var i = 0, n = small ? 80 : 160; i < n; i++) stars.push({ x: Math.random(), y: Math.random(), z: .25 + Math.random() * .75, r: Math.random(), p: Math.random() * 6.283, s: .4 + Math.random() * 1.4 });
    window.addEventListener('scroll', function () { if (!skyTick) { skyTick = true; requestAnimationFrame(skyScroll); } }, { passive: true });
    skyScroll();
  }
  function skyFrame(t) {
    if (!running) return;
    requestAnimationFrame(skyFrame);
    if (document.hidden || t - lastT < 32) return; lastT = t;
    cx.clearRect(0, 0, W, H);
    var sy = window.scrollY;
    for (var i = 0; i < stars.length; i++) {
      var s = stars[i], y = s.y * H - sy * s.z * .14; y = ((y % H) + H) % H;
      var x = s.x * W + Math.sin(t / 7000 * s.s + s.p) * 10 * s.z;
      var a = (.25 + .75 * (.5 + .5 * Math.sin(t / 850 * s.s + s.p))) * (.2 + .75 * s.z);
      var sz = (3 + s.r * 7) * s.z;
      cx.globalAlpha = a; cx.drawImage(dot, x - sz / 2, y - sz / 2, sz, sz);
    }
    cx.globalAlpha = 1;
  }
  function skyOn() { if (!has('sky') || !main) return; if (!sky) skyBuild(); if (!running) { running = true; requestAnimationFrame(skyFrame); } }
  function skyOff() { running = false; }

  /* 2) Licht an: Kacheln und Produktfenster schalten sich ein – beim Umschalten der Lichtwelle nach, sonst beim Hereinscrollen */
  var POWER = '.game, .card, .gallery__main', seen = typeof WeakSet === 'function' ? new WeakSet() : null;
  function power(list, base, origin) {
    list.forEach(function (el, i) {
      var d = base + i * 110;
      if (origin) { var r = el.getBoundingClientRect(); d = base + Math.hypot(r.left + r.width / 2 - origin.x, r.top + r.height / 2 - origin.y) / origin.r * 720; }
      el.style.setProperty('--pd', Math.round(d) + 'ms');
      el.classList.remove('mc-power'); void el.offsetWidth; el.classList.add('mc-power');
      clearTimeout(el._mcp); el._mcp = setTimeout(function () { el.classList.remove('mc-power'); }, d + 1700);
      if (seen) seen.add(el);
    });
  }
  function byPos(a, c) { var ra = a.getBoundingClientRect(), rc = c.getBoundingClientRect(); return (Math.round(ra.top / 40) - Math.round(rc.top / 40)) || (ra.left - rc.left); }
  if (has('power') && IO) {
    var pio = new IntersectionObserver(function (en) {
      if (!dark() || root.classList.contains('theme-switching')) return;
      var fresh = en.filter(function (e) { return e.isIntersecting && !(seen && seen.has(e.target)); }).map(function (e) { return e.target; });
      if (fresh.length) power(fresh.sort(byPos), 200, null);
    }, { threshold: 0 });
    qa(POWER).forEach(function (el) { pio.observe(el); });
  }

  /* 3) Lichtkanten: eine feine Lichtlinie läuft beim Einschalten einmal um jede Vitrine,
        danach leuchten die Kanten dort auf, wo Finger oder Maus gerade sind */
  var vis = typeof Set === 'function' ? new Set() : null;
  if ((has('edge') || has('power')) && vis) {
    var edgeEls = qa('.card, .game');
    edgeEls.forEach(function (el) {
      var g = document.createElement('span'); g.className = 'mc-glow'; g.setAttribute('aria-hidden', 'true');
      var e = document.createElement('span'); e.className = 'mc-edge'; e.setAttribute('aria-hidden', 'true');
      el.appendChild(g); el.appendChild(e);
    });
    if (has('edge') && IO) {
      var vio = new IntersectionObserver(function (en) { en.forEach(function (e) { if (e.isIntersecting) vis.add(e.target); else vis.delete(e.target); }); }, { rootMargin: '80px' });
      edgeEls.forEach(function (el) { vio.observe(el); });
      var px = -1e4, py = -1e4, pend = false, act = false;
      function upd() {
        pend = false; if (!dark()) return;
        vis.forEach(function (el) {
          var r = el.getBoundingClientRect();
          var dx = Math.max(r.left - px, 0, px - r.right), dy = Math.max(r.top - py, 0, py - r.bottom);
          var o = act ? Math.max(0, 1 - Math.hypot(dx, dy) / 150) : 0;
          if (o <= 0 && !el._mco) return;
          el._mco = o > 0;
          el.style.setProperty('--ex', Math.round(px - r.left) + 'px'); el.style.setProperty('--ey', Math.round(py - r.top) + 'px'); el.style.setProperty('--eo', o.toFixed(2));
        });
      }
      function move(x, y) { px = x; py = y; act = true; if (!pend) { pend = true; requestAnimationFrame(upd); } }
      function leave() { act = false; if (!pend) { pend = true; requestAnimationFrame(upd); } }
      window.addEventListener('pointermove', function (e) { if (e.pointerType === 'mouse') move(e.clientX, e.clientY); }, { passive: true });
      window.addEventListener('touchstart', function (e) { var t = e.touches[0]; if (t) move(t.clientX, t.clientY); }, { passive: true });
      window.addEventListener('touchmove', function (e) { var t = e.touches[0]; if (t) move(t.clientX, t.clientY); }, { passive: true });
      window.addEventListener('touchend', leave, { passive: true }); window.addEventListener('touchcancel', leave, { passive: true });
      /* Lichtkegel unter dem Finger */
      var fing = document.createElement('span'); fing.className = 'mc-finger'; fing.setAttribute('aria-hidden', 'true'); b.appendChild(fing);
      function fingAt(e) { var t = e.touches[0]; if (!t || !dark()) return; fing.style.transform = 'translate3d(' + Math.round(t.clientX) + 'px,' + Math.round(t.clientY) + 'px,0)'; fing.classList.add('is-on'); }
      window.addEventListener('touchstart', fingAt, { passive: true }); window.addEventListener('touchmove', fingAt, { passive: true });
      ['touchend', 'touchcancel'].forEach(function (ev) { window.addEventListener(ev, function () { fing.classList.remove('is-on'); }, { passive: true }); });
      document.addEventListener('mouseleave', leave);
      window.addEventListener('scroll', function () { if (act && !pend) { pend = true; requestAnimationFrame(upd); } }, { passive: true });
    }
  }

  /* Nachgeladene Karten („Mehr laden“) bekommen Lichtkanten und schalten ihr Licht ein */
  document.addEventListener('mc:cards', function (ev) {
    (ev.detail || []).forEach(function (n) {
      var list = n.matches && n.matches('.card, .game') ? [n] : qa('.card, .game', n);
      list.forEach(function (el) {
        if ((has('edge') || has('power')) && vis && !el.querySelector('.mc-edge')) {
          var g = document.createElement('span'); g.className = 'mc-glow'; g.setAttribute('aria-hidden', 'true');
          var e2 = document.createElement('span'); e2.className = 'mc-edge'; e2.setAttribute('aria-hidden', 'true');
          el.appendChild(g); el.appendChild(e2);
          if (typeof vio !== 'undefined' && vio) vio.observe(el);
        }
        if (typeof pio !== 'undefined' && pio) pio.observe(el);
      });
    });
  });

  /* 4) Lichtimpuls beim Tippen (nur echte Tipper, nicht beim Scrollen) */
  if (has('tap')) {
    var lastTouch = 0;
    window.addEventListener('touchstart', function () { lastTouch = Date.now(); }, { passive: true });
    document.addEventListener('click', function (e) {
      if (!dark() || Date.now() - lastTouch > 900 || !e.clientX && !e.clientY) return;
      var s = document.createElement('span'); s.className = 'mc-tap'; s.setAttribute('aria-hidden', 'true');
      s.style.left = e.clientX + 'px'; s.style.top = e.clientY + 'px'; b.appendChild(s);
      setTimeout(function () { s.remove(); }, 900);
    }, true);
  }

  /* Umschalten: Himmel an/aus, Vitrinen folgen der Lichtwelle vom Schalter aus */
  function onTheme() {
    if (!dark()) { skyOff(); return; }
    skyOn();
    if (!has('power')) return;
    var list = qa(POWER).filter(inView);
    if (root.classList.contains('theme-switching')) {
      var st = root.style, o = { x: parseFloat(st.getPropertyValue('--vx')) || innerWidth, y: parseFloat(st.getPropertyValue('--vy')) || 0, r: parseFloat(st.getPropertyValue('--vr')) || innerHeight };
      power(list, 160, o);
      /* Danach fährt ein Lichtschwenk einmal über die Seite */
      setTimeout(function () { if (!dark()) return; var sw = document.createElement('span'); sw.className = 'mc-sweep'; sw.setAttribute('aria-hidden', 'true'); b.appendChild(sw); setTimeout(function () { sw.remove(); }, 1700); }, 820);
    } else power(list.sort(byPos), 200, null);
  }
  if (window.MutationObserver) new MutationObserver(onTheme).observe(root, { attributes: true, attributeFilter: ['data-theme'] });
  if (dark()) skyOn();
})();

/* ===== Komfort-Funktionen: Variante auf der Karte, Merkliste, Zuletzt angesehen, Vollbild-Zoom,
   Mehr laden, Kalender-Knopf, Preis pro Booster, „Passt dazu“ im Warenkorb ===== */
(function () {
  var cfg = window.themeConfig || {}, F = cfg.features || {}, b = document.body;
  if (!b) return;
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function load(k) { try { return JSON.parse(localStorage.getItem(k) || '[]'); } catch (e) { return []; } }
  function save(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var heart = '<svg class="icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.3s-7.6-4.5-9.3-9.3C1.5 7.5 3.9 4.4 7.2 4.4c2 0 3.7 1.1 4.8 2.8 1.1-1.7 2.8-2.8 4.8-2.8 3.3 0 5.7 3.1 4.5 6.6-1.7 4.8-9.3 9.3-9.3 9.3z"/></svg>';
  function money(v, like) { /* Zahl im Stil eines vorhandenen Preises ausgeben */
    var n = v.toFixed(2).replace('.', ','), t = String(like || '');
    if (/^\s*(ab\s*)?€/.test(t)) return '€' + n; return n + ' €';
  }
  function num(t) {
    var s = String(t).replace(/[^\d,.]/g, '');
    if (/,\d{1,2}$/.test(s)) s = s.replace(/\./g, '').replace(',', '.'); else s = s.replace(/,/g, '');
    var v = parseFloat(s); return isFinite(v) ? v : null;
  }

  /* 1) Variante (z. B. Sprache) direkt auf der Karte wählen: Preis folgt der Auswahl */
  function chipPrice(input) {
    var card = input.closest('.card'), box = card && $('.card__body .price', card); if (!box) return;
    var p = input.getAttribute('data-price'), c = input.getAttribute('data-compare');
    box.classList.toggle('price--sale', !!c);
    box.innerHTML = (c ? '<s class="price__compare">' + esc(c) + '</s>' : '') + '<span class="price__current">' + esc(p) + '</span>';
    perBooster(card);
  }
  function initChips(root) { $$('.vchips input:checked', root).forEach(chipPrice); }
  document.addEventListener('change', function (e) { if (e.target.matches && e.target.matches('.vchips input')) chipPrice(e.target); });

  /* 2) Preis pro Booster bei Displays, berechnet aus dem Titel („Display (24 Booster)“, „24er Display“) */
  function boosterCount(title) {
    var t = String(title || '');
    if (!/display|booster[\s-]?box|boosterbox/i.test(t)) return 0;
    var m = t.match(/(\d{1,3})\s*(?:x\s*)?booster(?![\s-]?box)/i) || t.match(/(\d{1,3})er[\s-]*(?:booster[\s-]*)?display/i);
    var n = m ? parseInt(m[1], 10) : 0; return n >= 2 && n <= 60 ? n : 0;
  }
  function perBooster(scope) {
    if (!F.perBooster || !scope) return;
    var titleEl = $('.card__title', scope) || $('.product__title', scope), priceEl = $('.price__current', scope);
    var old = $('.ppb', scope); if (old) old.remove();
    if (!titleEl || !priceEl || /ab|folgt/i.test(priceEl.textContent)) return;
    var n = boosterCount(titleEl.textContent), v = num(priceEl.textContent); if (!n || !v) return;
    var p = document.createElement('p'); p.className = 'ppb'; p.textContent = '≈ ' + money(v / n, priceEl.textContent) + ' pro Booster';
    var box = priceEl.closest('.price'); box.parentNode.insertBefore(p, box.nextSibling);
  }
  function initPerBooster(root) { $$('.card', root).forEach(perBooster); }
  var pInfo = $('.product__info');
  if (pInfo && F.perBooster) {
    perBooster(pInfo);
    var pbx = $('[data-price]', pInfo);
    if (pbx && window.MutationObserver) new MutationObserver(function () { perBooster(pInfo); }).observe(pbx, { childList: true, subtree: true });
  }

  /* 3) Kalender-Knopf bei Release-Terminen (.ics für iPhone, Android, Outlook) */
  function icsDate(d) { return d.getFullYear() + ('0' + (d.getMonth() + 1)).slice(-2) + ('0' + d.getDate()).slice(-2); }
  function icsText(t) { return String(t).replace(/\\/g, '\\\\').replace(/;/g, '\;').replace(/,/g, '\\,').replace(/\n/g, '\\n'); }
  function addIcs(root) {
    if (!F.ics) return;
    $$('.card__release', root).forEach(function (el) {
      if ($('.ics-btn', el)) return;
      var m = el.textContent.match(/(\d{2})\.(\d{2})\.(\d{4})/); if (!m) return;
      var d = new Date(+m[3], +m[2] - 1, +m[1]); if (d < new Date(new Date().toDateString())) return;
      var bt = document.createElement('button'); bt.type = 'button'; bt.className = 'ics-btn';
      bt.innerHTML = '<svg class="icon icon--sm" viewBox="0 0 24 24" aria-hidden="true"><rect x="3.5" y="5" width="17" height="15.5" rx="2.5"/><path d="M3.5 10h17M8 3v4M16 3v4M12 13v5M9.5 15.5h5"/></svg><span>Kalender</span>';
      bt.setAttribute('aria-label', 'Release-Termin in den Kalender eintragen');
      bt.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var card = el.closest('.card'), info = el.closest('.product__info');
        var title = ((card && $('.card__title', card)) || (info && $('.product__title', info)) || {}).textContent || 'Release';
        var link = card ? ($('.card__title a', card) || {}).href : location.href.split('?')[0];
        title = title.trim(); var d2 = new Date(d.getTime() + 864e5), now = new Date();
        var stamp = now.toISOString().replace(/[-:]/g, '').replace(/\.\d+Z$/, 'Z');
        var ics = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//' + icsText(cfg.shopName || 'Shop') + '//Release//DE', 'CALSCALE:GREGORIAN', 'METHOD:PUBLISH', 'BEGIN:VEVENT',
          'UID:' + icsDate(d) + '-' + title.replace(/[^\w]+/g, '-').slice(0, 40) + '@memento', 'DTSTAMP:' + stamp, 'DTSTART;VALUE=DATE:' + icsDate(d), 'DTEND;VALUE=DATE:' + icsDate(d2),
          'SUMMARY:' + icsText('Release: ' + title), 'DESCRIPTION:' + icsText((cfg.shopName || '') + ' – ' + (link || '')), 'URL:' + (link || ''),
          'BEGIN:VALARM', 'TRIGGER:-PT15H', 'ACTION:DISPLAY', 'DESCRIPTION:' + icsText('Morgen ist Release: ' + title), 'END:VALARM', 'END:VEVENT', 'END:VCALENDAR'].join('\r\n');
        var a = document.createElement('a'); a.href = 'data:text/calendar;charset=utf-8,' + encodeURIComponent(ics);
        a.download = 'release-' + icsDate(d) + '.ics'; document.body.appendChild(a); a.click(); a.remove();
        bt.classList.add('is-done'); bt.querySelector('span').textContent = 'Eingetragen';
      });
      el.appendChild(bt);
    });
  }

  /* 4) Merkliste: Herz auf Karten und Produktseite, Liste als Schublade, Herz im Header erst mit Einträgen */
  var wish = load('mcWish'), wDrawer = null, wLink = null;
  function wishHas(h) { return wish.some(function (x) { return x.h === h; }); }
  function markHearts(root) { $$('[data-wish]', root).forEach(function (bt) { var on = wishHas(bt.getAttribute('data-wish')); bt.classList.toggle('is-on', on); bt.setAttribute('aria-pressed', String(on)); }); }
  function wishHeader() {
    if (!F.wishlist) return;
    var acts = $('.header__actions'); if (!acts) return;
    if (!wLink) {
      wLink = document.createElement('button'); wLink.type = 'button'; wLink.className = 'action wish-link'; wLink.setAttribute('aria-label', 'Merkliste öffnen');
      wLink.innerHTML = heart + '<span class="action__text"><b>Merkliste</b><small data-wish-n></small></span><span class="wish-count" data-wish-c></span>';
      var cart = $('.cart-link', acts); acts.insertBefore(wLink, cart || null);
      wLink.addEventListener('click', openWish);
    }
    var n = wish.length; wLink.hidden = n === 0; b.classList.toggle('has-wish', n > 0);
    $('[data-wish-c]', wLink).textContent = n; $('[data-wish-n]', wLink).textContent = n + (n === 1 ? ' Artikel' : ' Artikel');
  }
  function buildWish() {
    wDrawer = document.createElement('div'); wDrawer.className = 'drawer wish-drawer'; wDrawer.id = 'WishDrawer'; wDrawer.setAttribute('aria-hidden', 'true');
    wDrawer.innerHTML = '<div class="drawer__overlay" data-drawer-close></div><aside class="drawer__panel" role="dialog" aria-modal="true" aria-label="Merkliste"><div class="drawer__inner"><div class="drawer__head"><h2>Merkliste <span class="muted" data-wish-head></span></h2><button type="button" class="icon-btn" data-drawer-close aria-label="Schließen"><svg class="icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button></div><div class="wish-list" data-wish-list></div></div></aside>';
    document.body.appendChild(wDrawer);
    wDrawer.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-wish-remove]'); if (!rm) return;
      e.preventDefault(); toggleWish({ h: rm.getAttribute('data-wish-remove') }, false); renderWish();
    });
  }
  function renderWish() {
    if (!wDrawer) return;
    $('[data-wish-head]', wDrawer).textContent = '(' + wish.length + ')';
    var list = $('[data-wish-list]', wDrawer);
    if (!wish.length) { list.innerHTML = '<div class="drawer__empty"><p>Noch nichts gemerkt.</p><p class="muted small">Tippe auf das Herz bei einem Produkt, um es hier zu sammeln.</p></div>'; return; }
    list.innerHTML = wish.map(function (x) {
      return '<div class="wish-item"><a class="wish-item__media" href="' + esc(x.u) + '">' + (x.i ? '<img src="' + esc(x.i) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="wish-item__body"><a class="wish-item__title" href="' + esc(x.u) + '">' + esc(x.t) + '</a><span class="wish-item__price">' + esc(x.p || '') + '</span>' +
        '<a class="link-arrow wish-item__go" href="' + esc(x.u) + '">Zum Produkt</a></div>' +
        '<button type="button" class="icon-btn wish-item__rm" data-wish-remove="' + esc(x.h) + '" aria-label="' + esc(x.t) + ' entfernen"><svg class="icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button></div>';
    }).join('');
  }
  function openWish() { if (!wDrawer) buildWish(); renderWish(); if (window.mementoUI) window.mementoUI.open(wDrawer); }
  function toggleWish(item, on) {
    var has = wishHas(item.h); if (on == null) on = !has;
    if (on && !has) wish.unshift(item); if (!on) wish = wish.filter(function (x) { return x.h !== item.h; });
    wish = wish.slice(0, 40); save('mcWish', wish); markHearts(); wishHeader();
  }
  if (F.wishlist) {
    document.addEventListener('click', function (e) {
      var bt = e.target.closest('[data-wish]'); if (!bt) return;
      e.preventDefault(); e.stopPropagation();
      var on = !bt.classList.contains('is-on');
      toggleWish({ h: bt.getAttribute('data-wish'), t: bt.getAttribute('data-wish-title'), u: bt.getAttribute('data-wish-url'), i: bt.getAttribute('data-wish-img'), p: bt.getAttribute('data-wish-price') }, on);
      if (on && !calm && bt.animate) bt.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.32)' }, { transform: 'scale(1)' }], { duration: 420, easing: 'cubic-bezier(.2,.8,.2,1)' });
      if (on && wLink && !calm && wLink.animate) wLink.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.18)' }, { transform: 'scale(1)' }], { duration: 480, delay: 120, easing: 'cubic-bezier(.2,.8,.2,1)' });
    }, true);
    window.addEventListener('storage', function (e) { if (e.key === 'mcWish') { wish = load('mcWish'); markHearts(); wishHeader(); renderWish(); } });
    markHearts(); wishHeader();
  }

  /* 5) Zuletzt angesehen */
  var meta = $('[data-product-meta]');
  if (F.recent && meta) {
    try {
      var cur = JSON.parse(meta.textContent);
      var seen = load('mcSeen').filter(function (x) { return x.h !== cur.h; }); seen.unshift(cur); save('mcSeen', seen.slice(0, 16));
    } catch (e) {}
  }
  $$('[data-recent]').forEach(function (sec) {
    var ex = sec.getAttribute('data-exclude'), lim = +sec.getAttribute('data-limit') || 8;
    var items = load('mcSeen').filter(function (x) { return x.h && x.h !== ex; }).slice(0, lim);
    if (!items.length) return;
    $('[data-recent-list]', sec).innerHTML = items.map(function (x) {
      return '<a class="rv-card" role="listitem" href="' + esc(x.u) + '"><span class="rv-card__media">' + (x.i ? '<img src="' + esc(x.i) + '" alt="" loading="lazy">' : '') + '</span>' +
        '<span class="rv-card__title">' + esc(x.t) + '</span><span class="rv-card__price">' + esc(x.p || '') + '</span></a>';
    }).join('');
    sec.hidden = false;
  });

  /* 6) Vollbild-Zoom: Wischen, Doppeltippen, mit zwei Fingern zoomen, ziehen */
  var gm = F.zoom && $('[data-product] .gallery__main');
  if (gm) {
    gm.classList.add('has-zoom');
    var zbtn = document.createElement('button'); zbtn.type = 'button'; zbtn.className = 'zoom-open'; zbtn.setAttribute('aria-label', 'Bilder im Vollbild ansehen');
    zbtn.innerHTML = '<svg class="icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M14 4h6v6M10 20H4v-6M20 4l-7 7M4 20l7-7"/></svg>';
    gm.appendChild(zbtn);
    var Z = null, zi = 0, zs = [], st = { s: 1, x: 0, y: 0 }, ptr = {}, drag = null, lastTap = 0;
    function bigSrc(img) {
      var best = img.currentSrc || img.src, bw = 0;
      (img.getAttribute('srcset') || '').split(',').forEach(function (c) { var p = c.trim().split(/\s+/), w = parseInt(p[1], 10) || 0; if (w > bw) { bw = w; best = p[0]; } });
      return best;
    }
    function buildZoom() {
      var imgs = $$('.gallery__slide img', gm);
      Z = document.createElement('div'); Z.className = 'zoom'; Z.setAttribute('role', 'dialog'); Z.setAttribute('aria-modal', 'true'); Z.setAttribute('aria-label', 'Produktbilder im Vollbild');
      Z.innerHTML = '<div class="zoom__track">' + imgs.map(function (im) { return '<div class="zoom__slide"><img src="' + esc(bigSrc(im)) + '" alt="' + esc(im.alt || '') + '" draggable="false"></div>'; }).join('') + '</div>' +
        '<button type="button" class="zoom__close" aria-label="Schließen"><svg class="icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button>' +
        (imgs.length > 1 ? '<button type="button" class="zoom__nav zoom__nav--prev" aria-label="Vorheriges Bild">‹</button><button type="button" class="zoom__nav zoom__nav--next" aria-label="Nächstes Bild">›</button><p class="zoom__count" aria-live="polite"></p>' : '') +
        '<p class="zoom__hint">Doppeltippen oder mit zwei Fingern zoomen</p>';
      document.body.appendChild(Z);
      zs = $$('.zoom__slide img', Z);
      $('.zoom__close', Z).addEventListener('click', closeZoom);
      if (imgs.length > 1) { $('.zoom__nav--prev', Z).addEventListener('click', function () { go(zi - 1); }); $('.zoom__nav--next', Z).addEventListener('click', function () { go(zi + 1); }); }
      var tr = $('.zoom__track', Z);
      tr.addEventListener('pointerdown', down); tr.addEventListener('pointermove', move); tr.addEventListener('pointerup', up); tr.addEventListener('pointercancel', up);
      tr.addEventListener('wheel', function (e) { if (!e.ctrlKey && Math.abs(e.deltaY) < 4) return; e.preventDefault(); zoomTo(Math.min(5, Math.max(1, st.s * (e.deltaY < 0 ? 1.15 : 0.87))), e.clientX, e.clientY); }, { passive: false });
    }
    function apply(anim) {
      var im = zs[zi]; if (!im) return;
      im.style.transition = anim ? 'transform .3s cubic-bezier(.2,.8,.2,1)' : 'none';
      im.style.transform = 'translate3d(' + st.x + 'px,' + st.y + 'px,0) scale(' + st.s + ')';
      Z.classList.toggle('is-zoomed', st.s > 1.01);
    }
    function clamp() {
      var im = zs[zi]; if (!im) return; var w = im.offsetWidth * st.s, h = im.offsetHeight * st.s;
      var mx = Math.max(0, (w - innerWidth) / 2), my = Math.max(0, (h - innerHeight) / 2);
      st.x = Math.max(-mx, Math.min(mx, st.x)); st.y = Math.max(-my, Math.min(my, st.y));
    }
    function zoomTo(s, cx, cy, anim) {
      var im = zs[zi]; if (!im) return; var r = im.getBoundingClientRect();
      var ox = cx - (r.left + r.width / 2), oy = cy - (r.top + r.height / 2), k = s / st.s;
      st.x = st.x - ox * (k - 1); st.y = st.y - oy * (k - 1); st.s = s;
      if (s <= 1.01) { st.s = 1; st.x = 0; st.y = 0; } clamp(); apply(anim);
    }
    function toggleAt(x, y) { zoomTo(st.s > 1.01 ? 1 : 2.6, x, y, true); }
    function go(i, anim) {
      if (!Z) return; var n = zs.length; i = Math.max(0, Math.min(n - 1, i));
      if (i !== zi) { st = { s: 1, x: 0, y: 0 }; apply(false); }
      zi = i; var tr = $('.zoom__track', Z);
      tr.style.transition = anim === false ? 'none' : 'transform .4s cubic-bezier(.2,.8,.2,1)'; tr.style.transform = 'translate3d(' + (-zi * 100) + 'vw,0,0)';
      var c = $('.zoom__count', Z); if (c) c.textContent = (zi + 1) + ' / ' + n;
      Z.classList.toggle('is-first', zi === 0); Z.classList.toggle('is-last', zi === n - 1);
    }
    function down(e) {
      e.preventDefault(); this.setPointerCapture && this.setPointerCapture(e.pointerId);
      ptr[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(ptr);
      if (ids.length === 2) { var a = ptr[ids[0]], c = ptr[ids[1]]; drag = { pinch: true, d: Math.hypot(a.x - c.x, a.y - c.y), s: st.s, mx: (a.x + c.x) / 2, my: (a.y + c.y) / 2 }; }
      else drag = { x: e.clientX, y: e.clientY, sx: st.x, sy: st.y, t: Date.now(), moved: false };
    }
    function move(e) {
      if (!ptr[e.pointerId] || !drag) return; ptr[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(ptr);
      if (drag.pinch && ids.length >= 2) {
        var a = ptr[ids[0]], c = ptr[ids[1]], d = Math.hypot(a.x - c.x, a.y - c.y);
        zoomTo(Math.min(5, Math.max(1, drag.s * d / drag.d)), (a.x + c.x) / 2, (a.y + c.y) / 2); return;
      }
      var dx = e.clientX - drag.x, dy = e.clientY - drag.y; if (Math.abs(dx) + Math.abs(dy) > 6) drag.moved = true;
      if (st.s > 1.01) { st.x = drag.sx + dx; st.y = drag.sy + dy; clamp(); apply(false); }
      else {
        var edge = (zi === 0 && dx > 0) || (zi === zs.length - 1 && dx < 0) ? .35 : 1, tr = $('.zoom__track', Z);
        tr.style.transition = 'none'; tr.style.transform = 'translate3d(calc(' + (-zi * 100) + 'vw + ' + (dx * edge) + 'px),0,0)';
        if (Math.abs(dy) > 90 && Math.abs(dy) > Math.abs(dx) * 1.4) Z.style.opacity = String(Math.max(.4, 1 - (Math.abs(dy) - 90) / 300));
      }
    }
    function up(e) {
      var wasPinch = drag && drag.pinch; delete ptr[e.pointerId];
      if (!drag) return;
      if (wasPinch) { if (!Object.keys(ptr).length) drag = null; else { var k = Object.keys(ptr)[0]; drag = { x: ptr[k].x, y: ptr[k].y, sx: st.x, sy: st.y, t: Date.now(), moved: true }; } return; }
      var dx = e.clientX - drag.x, dy = e.clientY - drag.y, dt = Date.now() - drag.t; Z.style.opacity = '';
      if (!drag.moved) {
        var now = Date.now();
        if (e.pointerType === 'touch' && now - lastTap < 320) { toggleAt(e.clientX, e.clientY); lastTap = 0; }
        else { lastTap = now; if (e.pointerType !== 'touch') toggleAt(e.clientX, e.clientY); }
      } else if (st.s <= 1.01) {
        if (Math.abs(dy) > 140 && Math.abs(dy) > Math.abs(dx) * 1.4) { closeZoom(); }
        else if (Math.abs(dx) > 60 || (Math.abs(dx) > 25 && dt < 250)) go(zi + (dx < 0 ? 1 : -1)); else go(zi);
      }
      drag = null;
    }
    function key(e) { if (!Z || !Z.classList.contains('is-open')) return; if (e.key === 'Escape') closeZoom(); else if (e.key === 'ArrowRight') go(zi + 1); else if (e.key === 'ArrowLeft') go(zi - 1); }
    var lastFocusZ = null;
    function openZoom() {
      if (!Z) buildZoom();
      var vis = $$('.gallery__slide', gm).filter(function (s) { return !!$('img', s); }), idx = vis.findIndex(function (s) { return !s.hidden; });
      st = { s: 1, x: 0, y: 0 }; zs.forEach(function (im) { im.style.transform = ''; });
      lastFocusZ = document.activeElement; Z.classList.add('is-open'); b.classList.add('no-scroll');
      go(idx < 0 ? 0 : idx, false); setTimeout(function () { var c = $('.zoom__close', Z); if (c) c.focus(); }, 60);
      document.addEventListener('keydown', key);
    }
    function closeZoom() {
      if (!Z) return; Z.classList.remove('is-open'); Z.style.opacity = '';
      if (!$('.drawer.is-open,.mobile-menu.is-open')) b.classList.remove('no-scroll');
      document.removeEventListener('keydown', key); if (lastFocusZ && lastFocusZ.focus) try { lastFocusZ.focus(); } catch (x) {}
    }
    zbtn.addEventListener('click', function (e) { e.preventDefault(); openZoom(); });
    gm.addEventListener('click', function (e) {
      if (e.target.closest('.zoom-open')) return;
      if (Date.now() - (gm._loupeAt || 0) < 700) return; /* gerade mit der Lupe (langes Drücken) geschaut */
      if (e.target.closest('.gallery__slide img, .gallery__slide')) openZoom();
    });
  }

  /* 7) Kategorien: „Mehr laden“ statt Seitenzahlen */
  document.addEventListener('click', async function (e) {
    var a = e.target.closest('[data-load-more]'); if (!a || !F.loadMore) return;
    e.preventDefault(); if (a.classList.contains('is-loading')) return;
    var grid = $('.collection__main .grid'); if (!grid) { location.href = a.href; return; }
    a.classList.add('is-loading'); a.setAttribute('aria-busy', 'true');
    try {
      var html = await (await fetch(a.href, { credentials: 'same-origin' })).text();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = $$('.collection__main .grid > *', doc);
      if (!fresh.length) throw new Error('leer');
      var added = fresh.map(function (n) { var x = document.importNode(n, true); grid.appendChild(x); return x; });
      added.forEach(function (n) { if (!calm && n.animate) n.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 450, easing: 'ease' }); });
      wireCards(added);
      var total = +a.getAttribute('data-total') || 0, shown = grid.children.length;
      var cnt = $('[data-load-more-count]'); if (cnt) cnt.textContent = Math.min(shown, total || shown) + ' von ' + (total || shown) + ' Artikeln';
      var bar = $('.load-more__bar span'); if (bar && total) bar.style.width = Math.min(100, shown / total * 100) + '%';
      var next = $('[data-load-more]', doc) || $('.pagination a[aria-label="Nächste Seite"]', doc);
      if (next && next.getAttribute('href')) { a.href = next.getAttribute('href'); a.classList.remove('is-loading'); a.removeAttribute('aria-busy'); }
      else a.remove();
    } catch (x) { location.href = a.href; }
  });

  /* 8) „Passt dazu“ im Warenkorb – Shopify schlägt passende Produkte vor */
  var recCache = {};
  async function fillRecs() {
    var box = $('#CartDrawer [data-cart-recs]'); if (!box || !F.cartRecs || box.getAttribute('data-done')) return;
    box.setAttribute('data-done', '1');
    var ids = (box.getAttribute('data-ids') || '').split(',').filter(Boolean); if (!ids.length) return;
    try {
      var list = recCache[ids[0]];
      if (!list) {
        var url = (cfg.recsUrl || '/recommendations/products') + '.json?product_id=' + ids[0] + '&limit=8&intent=related';
        var res = await fetch(url); if (!res.ok) return; list = (await res.json()).products || []; recCache[ids[0]] = list;
      }
      var pick = list.filter(function (p) { var v = (p.variants || []).find(function (x) { return x.available; }); return p.available && v && p.price > 0 && ids.indexOf(String(p.id)) < 0; }).slice(0, 3);
      if (!pick.length) return;
      box.innerHTML = '<p class="drawer__recs-title">Passt dazu</p>' + pick.map(function (p) {
        var v = p.variants.find(function (x) { return x.available; }), img = p.featured_image ? String(p.featured_image).replace(/^\/\//, 'https://') : '';
        var like = (($('#CartDrawer [data-drawer-inner]') || {}).getAttribute ? $('#CartDrawer [data-drawer-inner]').getAttribute('data-cart-total') : '') || '';
        var pr = money(p.price / 100, like);
        return '<div class="rec"><a class="rec__media" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + (img.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="" loading="lazy">' : '') + '</a>' +
          '<a class="rec__body" href="' + esc(p.url) + '"><span class="rec__title">' + esc(p.title) + '</span><span class="rec__price">' + pr + '</span></a>' +
          '<button type="button" class="rec__add" data-rec-add="' + v.id + '" aria-label="' + esc(p.title) + ' in den Warenkorb">+</button></div>';
      }).join('');
      box.hidden = false;
    } catch (e) {}
  }
  document.addEventListener('click', async function (e) {
    var bt = e.target.closest('[data-rec-add]'); if (!bt) return;
    e.preventDefault(); if (bt.classList.contains('is-loading')) return; bt.classList.add('is-loading');
    try {
      var r = await fetch(((cfg.routes && cfg.routes.add) || '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +bt.getAttribute('data-rec-add'), quantity: 1 }] }) });
      if (r.ok && window.mementoUI) await window.mementoUI.refreshCart();
    } catch (x) {} bt.classList.remove('is-loading');
  });
  var cd = $('#CartDrawer');
  if (cd && F.cartRecs && window.MutationObserver) { new MutationObserver(function () { fillRecs(); }).observe(cd, { childList: true, subtree: true }); fillRecs(); }

  /* Karten, die später dazukommen (Mehr laden), bekommen dieselben Helfer */
  function wireCards(nodes) {
    nodes.forEach(function (n) { initChips(n); initPerBooster(n); addIcs(n); markHearts(n); });
    try { document.dispatchEvent(new CustomEvent('mc:cards', { detail: nodes })); } catch (x) {}
  }
  initChips(document); initPerBooster(document); addIcs(document);
})();
